import { render, staticRenderFns } from "./DriversView.vue?vue&type=template&id=5fc5ab8e&scoped=true"
import script from "./DriversView.vue?vue&type=script&lang=js"
export * from "./DriversView.vue?vue&type=script&lang=js"
import style0 from "./DriversView.vue?vue&type=style&index=0&id=5fc5ab8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc5ab8e",
  null
  
)

export default component.exports